import { provideState } from '@ngrx/store';
import { exchangeRatesFeature } from './exchange-rates.reducer';
import { provideEffects } from '@ngrx/effects';
import { ExchangeRatesEffects } from './exchange-rates.effects';

export const ExchangeRatesFeatureProvides = [
  provideState(exchangeRatesFeature),
  provideEffects(ExchangeRatesEffects),
];
